"use client";

import { FoldersData, useFoldersData } from "@/hooks/useFolderData";
import React, { createContext, useContext, type ReactNode } from "react";

const FoldersContext = createContext<FoldersData | undefined>(undefined);

export const useFolders = () => {
  const ctx = useContext(FoldersContext);
  if (!ctx) throw new Error("useFolders must be used within a FoldersProvider");
  return ctx;
};

export function FoldersProvider({ children }: { children: ReactNode }) {
  const value = useFoldersData();

  return <FoldersContext.Provider value={value}>{children}</FoldersContext.Provider>;
}